import React from "react";
import PopupWrapper from "../../../components/PopupWrapper";
import { useForm } from "react-hook-form";
import FormBox from "../../../components/FormBox/FormBox";
import { AddChargesSchema } from "../../../Utils/formOptions";

const AddCharges = ({ showCharges, setShowCharges }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ ...AddChargesSchema });

  async function onSubmit(data) {}

  return (
    <PopupWrapper
      title={"Add Charges"}
      extraClass="width-800"
      Component={
        <div>
          <FormBox
            options={chargesArr}
            register={register}
            watch={watch}
            setValue={setValue}
            errors={errors}
          />

          <div className="d-flex justify-content-end mt-5">
            <button
              type="button"
              className="btn btn-secondary me-3"
              onClick={() => setShowCharges(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary text-white"
              onClick={handleSubmit(onSubmit)}
            >
              Create
            </button>
          </div>
        </div>
      }
      toShow={showCharges}
      closeEventHandler={() => {
        setShowCharges(false);
      }}
    />
  );
};

export default AddCharges;

const chargesArr = [
  {
    title: "Charge Type",
    field: "ChargeType",
    className: "col-12",
    type: "radio",
    options: [
      { title: "Credit", value: "Credit" },
      { title: "Debit", value: "Debit" },
    ],
  },
  {
    title: "Charge",
    field: "Charge",
    type: "select",
    className: "col-12",
    options: [
      { label: "Verification charges", value: "Verification charges" },
      { label: "Processing charges", value: "Processing charges" },
      { label: "Penalty on late payment", value: "Penalty on late payment" },
      { label: "Penalty for prepayment", value: "Penalty for prepayment" },
     ,
    ],
  },
  {
    title: "Amount",
    field: "Amount",
    type: "text",
    className: "col-12",
  },
];
